<template>
  <nna-container>
    <QRscan />
  </nna-container>
</template>

<script>
import QRscan from '@/modules/common/components/checkin/QRscan'
export default {
  name: 'Checkin',
  components: {
    QRscan
  },
  data() {
    return {

    }
  },
  mounted() {
    
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/checkin/pages/Checkin.vue